<template src="./main.html"></template>


<script>
import { mapState } from "vuex";

import BottomBar from "@/components/layout/BottomBar";
import ToolBar from "@/components/layout/ToolBar";

export default {
  components: {
    BottomBar,
    ToolBar,
  },

  data: () => ({
    menu: [],
    disabilitaBtn: false,
  }),

  methods: {
    async init() {
      try {
        // User info
        let res = await this.$store.dispatch("user/userInfo");

        this.menu = res.data.menu;
      } catch (error) {
        console.log(this.$functions.getErrorMsg(error));
        this.$toast.info(this.$functions.getErrorMsg(error));
      }
    },

    async esci() {
      this.disabilitaBtn = true;

      try {
        await this.$store.dispatch("auth/logout");
      } catch (error) {
        console.log(this.$functions.getErrorMsg(error));
      }
    },

    toggleDrawer() {
      this.$store.commit("app/setDrawer", true);
    },

    goto(link) {
      this.$router.push({ path: link });
    },
  },

  mounted() {
    this.init();
  },

  computed: {
    ...mapState({
      loading: (state) => state.app.loading,
      utente: (state) => state.user.displayName,
    }),

    getRole() {
      return this.$store.getters["user/getRole"];
    },

    utente() {
      return this.$store.getters["user/getDisplayName"];
    },
  },

};
</script>